module.exports = __webpack_public_path__ + "static/media/Logo.b09f9549.png";